export const getSelectedAssetName = asset => {
    return asset?.customer_alias || asset?.customerAlias || asset?.name
}

export const processAssetRequests = (requests, asset) => {
    return requests?.map(item => ({
        ...item,
        type: 'Repair',
        shipToId: asset?.shipto_id,
    }))
}

export const handleAssetUpdate = (asset, assetRequests, handlers) => {
    const {
        setListOfRequests,
        setSkipDuplicate,
        setAssetInfo,
        changeLoading,
    } = handlers

    // Add assetRequests to asset.openRequest
    asset.openRequests = assetRequests

    const processedRequests = processAssetRequests(assetRequests, asset)
    setListOfRequests(processedRequests)
    if (setSkipDuplicate) {
        setSkipDuplicate(processedRequests.length === 0)
    }
    setAssetInfo(asset)
    changeLoading(false)
}

export const checkDuplicates = async (
    asset,
    formatStoredOpenRequests,
    handlers,
) => {
    const assetRequests = formatStoredOpenRequests.filter(
        request => request.equipmentId === asset.salesforceID,
    )
    handleAssetUpdate(asset, assetRequests, handlers)
}
